
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { apiSlice } from '../apiSlice';

export const selectSessionRaw = (state: RootState) => apiSlice.endpoints.getSession.select()(state);

export const selectSessionLoaded = createSelector(
  [selectSessionRaw],
  (slice) => slice.status === 'fulfilled'
);

export const selectIsLoading = createSelector(
  [selectSessionRaw],
  (slice) =>  slice.isLoading
);

export const selectSessionStatus = createSelector(
  [selectSessionRaw],
  (slice) =>  slice.status
);

export const selectSessionData = createSelector(
  [selectSessionRaw],
  (slice) =>  slice.data
);

export const selectIsLoggedIn = createSelector(
  [selectSessionData],
  (slice) =>  !!slice?.isLoggedIn
);

export const selectCurrentUser = createSelector(
  [selectSessionData],
  (slice) =>  slice?.isLoggedIn ? slice.user : {}
);
